module.exports = __webpack_public_path__ + "media/era_sweepstakes/q2-1-500k-scholarship-era-sweeps-logo-lockup-a04ecb19.png";